//import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MenuDashboard from '../../../Components/shared/MenuDashboard';
import { AoOuvertIcons, CandidaturesRetenuesIcons, CandidaturesTraitesIcons, ChiffreAffaireIcons, CraValiderIcons, FactureNonPayeIcons, InterviewerIcons, MissionClotureesIcons, MissionEnCoursIcons, TotalCandidatureIcons } from '../../../data/SVGsDashbords';
import { parseDate } from '../DashbordBackOffice';

function BoxesCountStatusCandidatures({statusCandiaturesByCompanyId,backOffice,chiffreAffaire,DataForCandidatureRecuParAO,allCras,allStatusMissions}){
    BoxesCountStatusCandidatures.propTypes = {
        statusCandiaturesByCompanyId: PropTypes.any,
        DataForCandidatureRecuParAO:PropTypes.any,
        allCras:PropTypes.any,
        allStatusMissions:PropTypes.any,
        backOffice:PropTypes.any,
        chiffreAffaire:PropTypes.any,
    };
    const [totalCandidatures,setTotalCandidatures]=useState();
    const [candidatureInterview,setCandidatureInterview]=useState();
    const [candidatureUnread,setCandidatureUnread]=useState();
    const [countMissionEnCours,setCountMissionEnCours]=useState();
    const [countClosedMission,setCountClosedMission]=useState();
    const [chiffreAffaireCum,setChiffreAffaireCum]=useState();
    const [chiffreAffaireCumHover,setChiffreAffaireCumHover]=useState();
    const [notPayedFacturesClient,setNotPayedFacturesClient]=useState();
    const [notPayedFacturesExpert,setNotPayedFacturesExpert]=useState();
    const [aoOuvert,setAoOuvert]=useState();
    const [candidatRetenu,setCandidatRetenu]=useState();
    const [craVE,setCraVE]=useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorE2, setAnchorE2] = useState(null);
    const [anchorE3, setAnchorE3] = useState(null);
    const [anchorE4, setAnchorE4] = useState(null);
    const [anchorE5, setAnchorE5] = useState(null);
    const [anchorE6, setAnchorE6] = useState(null);
    const [anchorE7, setAnchorE7] = useState(null);
    const { i18n } = useTranslation();
    const [valueBesoinOuvertAO,setValueBesoinOuvertAo]=useState(0);
    const [valueBesoinOuvertCvthque,setValueBesoinOuvertCvtheque]=useState(0);
    const [valueCandidatRtnAo,setValueCandidatRtnAo]=useState(0);
    const [valueCandidatRtnCvtheque,setValueCandidatRtnCvtheque]=useState(0);
    const [valueCandidatIntrAo,setValueCandidatIntrAo]=useState(0);
    const [valueCandidatIntrCvtheque,setValueCandidatIntrCvtheque]=useState(0);
    const [valueCandidatUnreadAo,setValueCandidatUnreadAo]=useState(0);
    const [valueCandidatUnread2,setValueCandidatUnreadCvtheque]=useState(0);
    const [valueTotalCandidatAo,setValueTotalCandidatAo]=useState(0);
    const [valueTotalCandidatCvtheque,setValueTotalCandidatCvtheque]=useState(0);
    const [valueTotalFacturePayeExpert,setValueTotalFacturePayeExpert]=useState(0);
    const [valueTotalFacturePayeClient,setValueTotalFacturePayeClient]=useState(0);
    const [valueTotalRegularisationPayeExpert,setValueTotalRegularisationPayeExpert]=useState(0);
    const [valueTotalRegularisationPayeClient,setValueTotalRegularisationPayeClient]=useState(0);
    const navigate = useNavigate();

    // Function to calculate counts for different statuses of candidatures
    const calculateCounts = (data) => {
        const counts= {
            analyzed_count: 0,
            interesting_count: 0,
            interview_count: 0,
            rejected_count: 0,
            retained_count: 0,
            unread_count: 0,
            converted_Count:0,
        };
        data.forEach((item) => {
            const {status,statut } = item;
            if(statut=='open'){
                switch (status) {
                case 'unread':
                    counts.unread_count++;
                    break;
                case 'analyzed':
                    counts.analyzed_count++;
                    break;
                case 'rejected':
                    counts.rejected_count++;
                    break;
                case 'interview':
                    counts.interview_count++;
                    break;
                case 'interesting':
                    counts.interesting_count++;
                    break;
                case 'retained':
                    counts.retained_count++;
                    break;
                case 'converted':
                    counts.converted_Count++;
                    break;
                default:
                    break;
                }
            }
        });
        return counts;
    };

    // Function to calculate counts for different statuses of CRA
    const getStatusCraCounts = (data) => {
        const counts = {
            VE: 0, // En attente de validation Client
            NV: 0,
            pending: 0,
            VC: 0, // En attente de validation Client
            total: data.length
        };

        data.forEach(item => {
            const { statutCra } = item;
            counts[statutCra]++;
        });
        return counts;
    };

    // Counts the number of retained candidatures in the CVTheque and AO sources that are open.
    function countRetainedCandidatures(candidatures) {
        // Filter candidatures based on the specified conditions
        const retainedCVTheque = candidatures.filter(
            (candidature) =>
                candidature.status == 'retained' &&
                candidature.sourceCandidature == 'cvtheque' &&
                candidature.statut == 'open'
        );

        const retainedAO = candidatures.filter(
            (candidature) =>
                candidature.status == 'retained' &&
                candidature.sourceCandidature == 'ao' &&
                candidature.statut == 'open'
        );

        return {
            cvtheque: retainedCVTheque.length,
            ao: retainedAO.length,
        };
    }

    // Counts the number of interviewed candidatures in the CVTheque and AO sources that are open.
    function countInterviewedCandidatures(candidatures) {
        // Filter candidatures based on the specified conditions
        const InterviewedCVTheque = candidatures.filter(
            (candidature) =>
                candidature.status == 'interview' &&
                candidature.sourceCandidature == 'cvtheque' &&
                candidature.statut == 'open'
        );

        const InterviewedAO = candidatures.filter(
            (candidature) =>
                candidature.status == 'interview' &&
                candidature.sourceCandidature == 'ao' &&
                candidature.statut == 'open'
        );

        return {
            cvtheque: InterviewedCVTheque.length,
            ao: InterviewedAO.length,
        };
    }

    // Counts the number of unread candidatures in the CVTheque and AO sources that are open.
    function countUnreadCandidatures(candidatures) {
        // Filter candidatures based on the specified conditions
        const UnreadCVTheque = candidatures.filter(
            (candidature) =>
                candidature.status == 'unread' &&
                candidature.sourceCandidature == 'cvtheque' &&
                candidature.statut == 'open'
        );

        const UnreadAO = candidatures.filter(
            (candidature) =>
                candidature.status == 'unread' &&
                candidature.sourceCandidature == 'ao' &&
                candidature.statut == 'open'
        );

        return {
            cvtheque: UnreadCVTheque.length,
            ao: UnreadAO.length,
        };
    }

    // Counts the total number of candidatures in the CVTheque and AO sources that are open.
    function countTotalCandidatures(candidatures) {
        // Filter candidatures based on the specified conditions
        const TotalCVTheque = candidatures.filter(
            (candidature) =>
                candidature.sourceCandidature == 'cvtheque' &&
                candidature.statut == 'open'
        );

        const TotalAO = candidatures.filter(
            (candidature) =>
                candidature.sourceCandidature == 'ao' &&
                candidature.statut == 'open'
        );

        return {
            cvtheque: TotalCVTheque.length,
            ao: TotalAO.length,
        };
    }

    // Formats a large number into a more readable format with abbreviations for thousands, millions, and billions.
    const formatNumber = (number) => {
        if (Math.abs(number) >= 1.0e+9) {
            return (Math.abs(number) / 1.0e+9).toFixed(2) + ' B';
        } else if (Math.abs(number) >= 1.0e+6) {
            return (Math.abs(number) / 1.0e+6).toFixed(2) + ' M';
        } else if (Math.abs(number) >= 1.0e+3) {
            return (Math.abs(number) / 1.0e+3).toFixed(2) + ' K';
        } else {
            return number.toFixed(2);
        }
    };

    useEffect(() => {
        if (
            Array.isArray(statusCandiaturesByCompanyId) &&
            Array.isArray(DataForCandidatureRecuParAO) &&
            Array.isArray(allCras) &&
            Array.isArray(allStatusMissions) &&
            Array.isArray(chiffreAffaire)
        ) {
            let CountsListStatusCandidatures = calculateCounts(statusCandiaturesByCompanyId);

            let totalOpenCandidatures = DataForCandidatureRecuParAO.reduce((total, item) => {
                if (item.status === 'open' || item.status === 'encours') {
                    total += item?.candidature_count || 0;
                }
                return total;
            }, 0);

            setTotalCandidatures(totalOpenCandidatures);
            setCandidatureInterview(CountsListStatusCandidatures.interview_count);
            setCandidatRetenu(CountsListStatusCandidatures.retained_count);
            setCandidatureUnread(CountsListStatusCandidatures.unread_count);

            let countAoOuvert = 0;
            let countDossierOuvert = 0;

            DataForCandidatureRecuParAO.forEach((item) => {
                if (item.status === 'open') {
                    if (item.type === 'ao') {
                        countAoOuvert += 1;
                    } else if (item.type === 'cvtheque') {
                        countDossierOuvert += 1;
                    }
                }
            });

            let countMissionEncours = allStatusMissions.reduce((count, item) => {
                if (item.statutMission === 'encours' || item.statutMission === 'interruptionEnCours') {
                    count += 1;
                }
                return count;
            }, 0);

            let countMissioncloturer = allStatusMissions.reduce((count, item) => {
                if (item.statutMission === 'terminee' || item.statutMission === 'interompu') {
                    count += 1;
                }
                return count;
            }, 0);

            setCountMissionEnCours(countMissionEncours);
            setCountClosedMission(countMissioncloturer);
            setAoOuvert(countAoOuvert + countDossierOuvert);
            setValueBesoinOuvertAo(countAoOuvert);
            setValueBesoinOuvertCvtheque(countDossierOuvert);

            let countsCra = getStatusCraCounts(allCras);

            const { ao: retainedAo, cvtheque: retainedCvtheque } = countRetainedCandidatures(statusCandiaturesByCompanyId);
            setValueCandidatRtnAo(retainedAo);
            setValueCandidatRtnCvtheque(retainedCvtheque);

            const { ao: interviewedAo, cvtheque: interviewedCvtheque } = countInterviewedCandidatures(statusCandiaturesByCompanyId);
            setValueCandidatIntrAo(interviewedAo);
            setValueCandidatIntrCvtheque(interviewedCvtheque);

            const { ao: unreadAo, cvtheque: unreadCvtheque } = countUnreadCandidatures(statusCandiaturesByCompanyId);
            setValueCandidatUnreadAo(unreadAo);
            setValueCandidatUnreadCvtheque(unreadCvtheque);

            const { ao: totalCandidatAo, cvtheque: totalCandidatCvtheque } = countTotalCandidatures(statusCandiaturesByCompanyId);
            setValueTotalCandidatAo(totalCandidatAo);
            setValueTotalCandidatCvtheque(totalCandidatCvtheque);

            setCraVE(countsCra['VE']);

            let countFtrClientNonPaye = 0;
            let countRegularisationClientNonPaye = 0;
            let countFtrExpertNonPaye = 0;
            let countRegularisationExpertNonPaye = 0;
            let chiffreAffCum = 0;

            const currentDate = new Date();
            const startOfCurrentMonth = new Date(currentDate.getFullYear(), 0, 1);

            chiffreAffaire.forEach((item) => {
                if (item.totalHtClient && item.dateDebutAO != null && parseDate(item.dateDebutAO) >= startOfCurrentMonth) {
                    if (item.typeFacture !== 'factureXgroupe' && item.typeFacture !== 'factureNgroupe' && item.typeFacture !== 'factureX' && item.typeFacture !== 'regularisationX') {
                        chiffreAffCum += item.totalHtClient;
                    }
                }

                if (item.statutFacture === 'genere' && item.statutPaimentClient === 'nonPaye' && (item.typeFacture === 'facture' || item.typeFacture === 'factureG')) {
                    countFtrClientNonPaye += 1;
                }

                if (item.statutPaimentClient === 'nonPaye' && (item.typeFacture === 'regularisation' || item.typeFacture === 'regularisationX') && item.totalHtClient > 0) {
                    countRegularisationClientNonPaye += 1;
                }

                if ((item.typeFacture === 'facture' || item.typeFacture === 'factureX' || item.typeFacture === 'factureNgroupe' || item.typeFacture === 'factureXgroupe') && (item.statutFacture === 'genere' || item.statutFacture === 'groupe') && item.statutPaimentExpert === 'nonPaye') {
                    countFtrExpertNonPaye += 1;
                }

                if (item.statutPaimentExpert === 'nonPaye' && (item.typeFacture === 'regularisation' || item.typeFacture === 'regularisationX') && item.totalHtClient > 0) {
                    countRegularisationExpertNonPaye += 1;
                }
            });

            setChiffreAffaireCumHover(chiffreAffCum.toFixed(2));
            setNotPayedFacturesClient(countFtrClientNonPaye + countRegularisationClientNonPaye);
            setValueTotalRegularisationPayeExpert(countRegularisationExpertNonPaye);
            setValueTotalRegularisationPayeClient(countRegularisationClientNonPaye);
            setValueTotalFacturePayeClient(countFtrClientNonPaye);
            setValueTotalFacturePayeExpert(countFtrExpertNonPaye);
            setChiffreAffaireCum(formatNumber(chiffreAffCum));
            setNotPayedFacturesExpert(countFtrExpertNonPaye + countRegularisationExpertNonPaye);
        }
    }, [statusCandiaturesByCompanyId, allCras, chiffreAffaire, allStatusMissions, DataForCandidatureRecuParAO]);

    const openMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',gap:'24px',alignSelf:'stretch'}}>
                <div className='dashFrame0'>
                    {backOffice==true
                        ?
                        <div className='dashFrame1'>
                            <div className='dashFrame2'>
                                <AoOuvertIcons />
                                <h4 className='dashFrame3'>
                                    {aoOuvert}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Besoins ouverts')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorEl)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorEl}
                                anchorEl={anchorEl}
                                handleIconButtonClick={openMenu(setAnchorEl)}
                                label1={'AO'}
                                label2={'Cvtheque'}
                                value1={valueBesoinOuvertAO}
                                value2={valueBesoinOuvertCvthque}
                                filtre1={valueBesoinOuvertAO==0?true:false}
                                filtre2={valueBesoinOuvertCvthque==0?true:false}
                                link1={'/admin/aos'}
                                link2={'/admin/AllDossiers'}
                            />
                        </div>
                        :
                        <div className='dashFrame1'>
                            <div className='dashFrame2'>
                                <AoOuvertIcons color={'var(--border-primary, #9D9E9F)'}/>
                                <h4 className='dashFrame3'>
                                    {aoOuvert}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Besoins ouverts')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorEl)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorEl}
                                anchorEl={anchorEl}
                                handleIconButtonClick={openMenu(setAnchorEl)}
                                label1={'AO'}
                                label2={'Cvtheque'}
                                value1={valueBesoinOuvertAO}
                                value2={valueBesoinOuvertCvthque}
                                filtre1={valueBesoinOuvertAO==0?true:false}
                                filtre2={valueBesoinOuvertCvthque==0?true:false}
                                link1={'/client/aos'}
                                link2={'/client/AllMyDossier'}
                            />
                        </div>

                    }
                    {backOffice==true
                        ?
                        <div className='dashFrame1'>
                            <div className='dashFrame2'>
                                <CandidaturesRetenuesIcons color={'#EC5B56'}/>
                                <h4 className='dashFrame3'>
                                    {candidatRetenu}
                                </h4>

                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Candidats retenus')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE2)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE2}
                                anchorEl={anchorE2}
                                handleIconButtonClick={openMenu(setAnchorE2)}
                                label1={'AO'}
                                label2={'Cvtheque'}
                                value1={valueCandidatRtnAo}
                                value2={valueCandidatRtnCvtheque}
                                filtre1={valueCandidatRtnAo==0?true:false}
                                filtre2={valueCandidatRtnCvtheque==0?true:false}
                                candidatRetenu={true}
                                link1={'/admin/aos'}
                                link2={'/admin/AllDossiers'}
                            />
                        </div>
                        :
                        <div
                            className='dashFrame1'
                        >
                            <div className='dashFrame2'>
                                <TotalCandidatureIcons color={'#EC5B56'}/>
                                <h4 className='dashFrame3'>
                                    {totalCandidatures}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Total candidatures')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE5)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE5}
                                anchorEl={anchorE5}
                                handleIconButtonClick={openMenu(setAnchorE5)}
                                label1={'AO'}
                                label2={'Cvtheque'}
                                value1={valueTotalCandidatAo}
                                value2={valueTotalCandidatCvtheque}
                                filtre1={valueTotalCandidatAo==0?true:false}
                                filtre2={valueTotalCandidatCvtheque==0?true:false}
                                link1={'/client/aos'}
                                link2={'/client/AllMyDossier'}
                            />
                        </div>
                    }
                    {backOffice==true
                        ?
                        <div
                            className='dashFrame1'
                            style={{cursor:'pointer'}}
                            onClick={() => {
                                navigate('/admin/mission?filtreMissionEncours=true',{replace: true });
                            }}
                        >
                            <div className='dashFrame2'>
                                <MissionEnCoursIcons color={'#214DCE'}/>
                                <h4 className='dashFrame3'>
                                    {countMissionEnCours}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Missions en cours')}
                            </p>
                        </div>
                        :
                        <div className='dashFrame1'>
                            <div className='dashFrame2'>
                                <CandidaturesTraitesIcons/>
                                <h4 className='dashFrame3'>
                                    {candidatureUnread}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Candidatures à traiter')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE4)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE4}
                                anchorEl={anchorE4}
                                handleIconButtonClick={openMenu(setAnchorE4)}
                                label1={'AO'}
                                label2={'Cvtheque'}
                                value1={valueCandidatUnreadAo}
                                value2={valueCandidatUnread2}
                                filtre1={valueCandidatUnreadAo==0?true:false}
                                filtre2={valueCandidatUnread2==0?true:false}
                                candidatUnread={true}
                                link1={'/client/aos'}
                                link2={'/client/AllMyDossier'}
                            />
                        </div>
                    }
                    {backOffice==true
                        ?
                        <div
                            className='dashFrame1'
                            style={{cursor:'pointer'}}
                            onClick={() => {
                                navigate('/admin/mission?filtreMissionTermine=true', { replace: true });
                            }}
                        >
                            <div className='dashFrame2'>
                                <MissionClotureesIcons color={'#72C040'}/>
                                <h4 className='dashFrame3'>
                                    {countClosedMission}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Missions clôturées')}
                            </p>
                        </div>
                        :
                        <div className='dashFrame1'>
                            <div className='dashFrame2'>
                                <InterviewerIcons />
                                <h4 className='dashFrame3'>
                                    {candidatureInterview}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Candidat à interviewer')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE3)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE3}
                                anchorEl={anchorE3}
                                handleIconButtonClick={openMenu(setAnchorE3)}
                                label1={'AO'}
                                label2={'Cvtheque'}
                                value1={valueCandidatIntrAo}
                                value2={valueCandidatIntrCvtheque}
                                filtre1={valueCandidatIntrAo==0?true:false}
                                filtre2={valueCandidatIntrCvtheque==0?true:false}
                                candidatInterview={true}
                                link1={'/client/aos'}
                                link2={'/client/AllMyDossier'}
                            />
                        </div>
                    }
                </div>
                <div className='dashFrame0'>
                    <div
                        className='dashFrame1'
                        style={{cursor:'pointer'}}
                        onClick={() => {
                            if(backOffice==true)
                                navigate('/admin/AllCras?filtreCraAvalider=true',{replace: true });
                            else
                                navigate('/client/AllCras?filtreCraAvalider=true',{replace: true });
                        }}
                    >
                        <div className='dashFrame2'>
                            <CraValiderIcons />
                            <h4 className='dashFrame3'>
                                {craVE}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('CRA à valider')}
                        </p>
                    </div>
                    {backOffice==true
                        ?
                        <div
                            className='dashFrame1'
                        >
                            <div className='dashFrame2'>
                                <FactureNonPayeIcons color={'#EC5B56'}/>
                                <h4 className='dashFrame3'>
                                    {notPayedFacturesClient}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Factures clients non payées')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE7)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE7}
                                anchorEl={anchorE7}
                                handleIconButtonClick={openMenu(setAnchorE7)}
                                label1={'Factures'}
                                label2={'Regularisations'}
                                value1={valueTotalFacturePayeClient}
                                value2={valueTotalRegularisationPayeClient}
                                filtre1={valueTotalFacturePayeClient==0?true:false}
                                filtre2={valueTotalRegularisationPayeClient==0?true:false}
                                filtreFactureClientNonPaye={true}
                                link1={'/admin/AllFactures'}
                                link2={'/admin/AllRegularisation'}
                            />
                        </div>
                        :
                        <div
                            className='dashFrame1'
                            style={{cursor:'pointer'}}
                            onClick={() => {
                                navigate('/client/mission?filtreMissionEncours=true',{replace: true });
                            }}
                        >
                            <div className='dashFrame2'>
                                <MissionEnCoursIcons />
                                <h4 className='dashFrame3'>
                                    {countMissionEnCours}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Missions en cours')}
                            </p>
                        </div>
                    }
                    {backOffice==true
                        ?
                        <div
                            className='dashFrame1'
                        >
                            <div className='dashFrame2'>
                                <FactureNonPayeIcons color={'#214DCE'}/>
                                <h4 className='dashFrame3'>
                                    {notPayedFacturesExpert}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Factures experts non payées')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE6)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE6}
                                anchorEl={anchorE6}
                                handleIconButtonClick={openMenu(setAnchorE6)}
                                label1={'Factures'}
                                label2={'Regularisations'}
                                value1={valueTotalFacturePayeExpert}
                                value2={valueTotalRegularisationPayeExpert}
                                filtre1={valueTotalFacturePayeExpert==0?true:false}
                                filtre2={valueTotalRegularisationPayeExpert==0?true:false}
                                filtreFactureExpertNonPaye={true}
                                link1={'/admin/AllFactures'}
                                link2={'/admin/AllRegularisation'}
                            />
                        </div>
                        :
                        <div
                            className='dashFrame1'
                            style={{cursor:'pointer'}}
                            onClick={() => {
                                navigate('/client/mission?filtreMissionTermine=true',{replace: true });
                            }}
                        >
                            <div className='dashFrame2'>
                                <MissionClotureesIcons />
                                <h4 className='dashFrame3'>
                                    {countClosedMission}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Missions clôturées')}
                            </p>
                        </div>
                    }
                    {backOffice==true
                        ?
                        <Tooltip title={chiffreAffaireCumHover}>
                            <div
                                className='dashFrame1'
                                onClick={() => {
                                    navigate('/admin/statistiques/echancierMarges',{replace: true });
                                }}
                            >
                                <div className='dashFrame2'>
                                    <ChiffreAffaireIcons />
                                    <h4
                                        className='dashFrame3'
                                        style={{whiteSpace:'nowrap'}}
                                    >
                                        {chiffreAffaireCum ? chiffreAffaireCum +' €': ''}
                                    </h4>
                                </div>
                                <p className='dashFrame4'>
                                    {i18n.t('Chiffre d\'affaires')}
                                </p>
                            </div>
                        </Tooltip>
                        :
                        <div
                            className='dashFrame1'
                        >
                            <div className='dashFrame2'>
                                <FactureNonPayeIcons />
                                <h4 className='dashFrame3'>
                                    {notPayedFacturesClient}
                                </h4>
                            </div>
                            <p className='dashFrame4'>
                                {i18n.t('Factures non payées')}
                            </p>
                            <IconButton
                                style={{display:'flex',alignSelf:'end'}}
                                onClick={openMenu(setAnchorE7)}
                            >
                                <MoreHorizIcon/>
                            </IconButton>
                            <MenuDashboard
                                setAnchorEl={setAnchorE7}
                                anchorEl={anchorE7}
                                handleIconButtonClick={openMenu(setAnchorE7)}
                                label1={'Factures'}
                                label2={'Regularisations'}
                                value1={valueTotalFacturePayeClient}
                                value2={valueTotalRegularisationPayeClient}
                                filtre1={valueTotalFacturePayeClient==0?true:false}
                                filtre2={valueTotalRegularisationPayeClient==0?true:false}
                                filtreFactureClientNonPaye={true}
                                link1={'/client/AllFactures'}
                                link2={'/client/AllRegularisation'}
                            />
                        </div>
                    }
                </div>
            </div>
        </>
    );
}

export default BoxesCountStatusCandidatures;